import { type CartItem, type Currency } from 'ecosystem'

/**
 * Factory function to create GA4-compliant item objects
 * @param items - Cart items to convert
 * @param currencyCode - Currency code for the items
 * @param categoryMap - Optional map of category IDs to category names
 * @returns Array of GA4-formatted items
 */
export const ecommerceItemFactory = (
  items: CartItem[],
  currencyCode: Currency,
  categoryMap?: Record<string, string>
) => {
  return items.map((item, index) => {
    const categoryInfo: Record<string, string> = {}

    if (item.categoryIds && item.categoryIds.length > 0) {
      if (categoryMap) {
        // Add up to 5 categories (GA4 limit)
        for (let i = 0; i < Math.min(item.categoryIds.length, 5); i++) {
          const categoryId = item.categoryIds[i]
          const categoryName = categoryMap[categoryId] || ''

          if (i === 0) {
            categoryInfo.item_category = categoryName
          } else {
            categoryInfo[`item_category${i + 1}`] = categoryName
          }
        }
      } else {
        // If no category map provided, just use the IDs as placeholders
        categoryInfo.item_category = item.categoryIds[0] || ''

        for (let i = 1; i < Math.min(item.categoryIds.length, 5); i++) {
          categoryInfo[`item_category${i + 1}`] = item.categoryIds[i] || ''
        }
      }
    }

    return {
      item_id: item.id,
      item_name: item.name,
      item_brand: item?.brand?.name || '',
      price: item.price?.toFixed(2) || '0.00',
      quantity: parseFloat(item.qty || '1'),
      index,
      currency: currencyCode,
      ...categoryInfo
    }
  })
}
